/* eslint-disable camelcase */
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Box, Grid } from '@mui/material';
import _ from 'lodash';
import { MultiSelect } from 'react-multi-select-component';
import { useAppDispatch, useAppSelector } from '../../../../../../../hooks';
import './index.scss';
import TableSkeletonContainer from '../../../../pricing-simulator/components/simulation-table-container/table-skeleton';
import SkuListTable from './sku-list-table';
import {
  ISKUTableHeader,
  ISkuDetailsRow
} from '../../../types/duplicate-sku-model';

export default function SkuTableContent() {
  // app dispatch for dispatching actions
  const appDispatch = useAppDispatch();
  // Getting state from innovation
  const { duplicateSkuTableData, fetchingDuplicateSkuTable } = useAppSelector(
    (state) => state.innovation
  );

  const { existing_sku_data, new_sku_data } = duplicateSkuTableData;

  return (
    <>
      {fetchingDuplicateSkuTable ? (
        <Grid item xs={12} mt={1.5}>
          <TableSkeletonContainer rowLength={6} headerLength={6} />
        </Grid>
      ) : (
        <>
          {/* table container for new skus */}
          <Grid container>
            <SkuListTable
              // skuHeaderData={columnData}
              skuListData={new_sku_data}
              section='New SKU'
            />
          </Grid>
          {/* table container for existing skus */}
          <Grid container>
            <SkuListTable
              // skuHeaderData={columnData}
              skuListData={existing_sku_data}
              section='Existing SKU'
            />
          </Grid>
        </>
      )}
      {fetchingDuplicateSkuTable && (
        <Grid item xs={12}>
          <div
            style={{ textAlign: 'center', marginTop: '60px', fontSize: '20px' }}
          >
            No SKU Present.
          </div>
        </Grid>
      )}
    </>
  );
}
